// Provably-fair Crash («Ракетка»). Каноническая bustabit-формула:
// обычно 1–3x, изредка x10–100, очень редко x1000+. House edge ~1% (инстант-баст).
import { hmacSha256Hex } from './index';
export const CRASH_GROWTH_K = 0.2; // скорость роста множителя (1/сек, экспонента)
export const CRASH_BETTING_MS = 6000;
export const CRASH_COOLDOWN_MS = 4500;
export const CRASH_TICK_MS = 60;
export const CRASH_MAX = 10000; // потолок множителя (чтобы раунд не длился вечно)
// Точка краша из сидов. Детерминированно, проверяемо.
export function crashPointFrom(serverSeed, clientSeed, nonce) {
    const hash = hmacSha256Hex(serverSeed, `${clientSeed}:${nonce}`);
    // House edge: ~1/101 раундов мгновенно крашатся на 1.00x.
    const bustBytes = parseInt(hash.slice(13, 21), 16);
    if (bustBytes % 101 === 0)
        return 1.0;
    const h = parseInt(hash.slice(0, 13), 16); // первые 52 бита
    const e = 2 ** 52;
    const result = Math.floor((100 * e - h) / (e - h)) / 100;
    return Math.min(CRASH_MAX, Math.max(1.0, result));
}
export const verifyCrashPoint = crashPointFrom;
// Множитель в момент elapsedMs — ОДНА формула для сервера и клиента.
export function crashMultiplierAt(elapsedMs) {
    if (elapsedMs <= 0)
        return 1.0;
    const m = Math.exp(CRASH_GROWTH_K * (elapsedMs / 1000));
    return Math.floor(m * 100) / 100;
}
// Время (мс) до достижения множителя m — длительность фазы RUNNING.
export function crashDurationMs(crashPoint) {
    if (crashPoint <= 1)
        return 0;
    return (Math.log(crashPoint) / CRASH_GROWTH_K) * 1000;
}
//# sourceMappingURL=crash.js.map